import Sortable, { Swap } from 'sortablejs';

// Opt-in per list with `swap: true`. The UMD build mounts it already, and mounting twice throws.
try {
  Sortable.mount(new Swap());
} catch {
  // already mounted
}

export const sortItem = (item, items, direction) => {
  const index = items.indexOf(item);
  const destination = direction === 'down' ? index + 1 : index - 1;

  items.splice(index, 1); // delete from current position
  items.splice(destination, 0, item); // insert in new position

  return items;
};

const sortableConfig = (onSortEnd, options) => ({
  animation: 150,
  handle: '.drag-handle',
  onEnd: function (evt) {
    if (evt.oldIndex !== evt.newIndex) {
      onSortEnd(evt.oldIndex, evt.newIndex);
    }
  },
  ...options,
});

let sortableInstance = null;

export const destroySortable = () => {
  if (sortableInstance) {
    sortableInstance.destroy();
    sortableInstance = null;
  }
};

export const createSortable = (el, onSortEnd, options = {}) => {
  destroySortable();

  if (!el) return;

  sortableInstance = Sortable.create(el, sortableConfig(onSortEnd, options));

  return sortableInstance;
};

/**
 * A sortable list the caller owns, instead of the shared instance above.
 *
 * createSortable keeps one instance for the whole app, so a second list calling it destroys the
 * first one's — and the first list has no way of knowing it should build itself again. That is
 * exactly the case for a sortable list inside a modal opened over the parts list: it must leave
 * the list underneath draggable for when the modal closes. Such a list holds its own instance and
 * destroys it on unmount.
 */
export const createScopedSortable = (el, onSortEnd, options = {}) =>
  el ? Sortable.create(el, sortableConfig(onSortEnd, options)) : null;
